// @ts-ignore
import {StatusLoginEnum} from "@/enums/status-login.enum";
import TiposMutationAuth from "./tipos-mutation.auth";
import {MapActions} from "./map-actions.auth";
import UsuarioModel from "@/models/usuario.model";

const auth = {
    namespaced: true,
    state: () => ({
        status: StatusLoginEnum.NAO_LOGADO,
        usuarioLogado: new UsuarioModel(),
    }),
    mutations: {
        [TiposMutationAuth.SET_STATUS_LOGIN](state, payload) {
            state.status = payload;
        },
        [TiposMutationAuth.SET_USUARIO_LOGADO](state, payload) {
            state.usuarioLogado = payload;
        }
    },
    actions: {
        [MapActions.ALTERAR_STATUS_LOGIN]({commit}, status) {
            commit(TiposMutationAuth.SET_STATUS_LOGIN, status);
        },
        [MapActions.SALVAR_USUARIO_LOGADO]({commit, state}, usuarioLogado) {
            commit(TiposMutationAuth.SET_USUARIO_LOGADO, usuarioLogado);
        },
        [MapActions.DESLOGAR_USUARIO]({commit, state}, vue) {
            commit(TiposMutationAuth.SET_USUARIO_LOGADO, {});
            commit(TiposMutationAuth.SET_STATUS_LOGIN, StatusLoginEnum.NAO_LOGADO);
            if (localStorage.jwt) {
                // Limpa o localStorage
                localStorage.clear();
                // Manda pro login
                vue.$router.push('/');
            }
        }
    },
    getters: {
        id: state => {
            return state.usuarioLogado.id;
        },
        nome: state => {
            return state.usuarioLogado.name;
        },
        email: state => {
            return state.usuarioLogado.email;
        },
        status: state => {
            return state.status;
        }
    }
}

export default auth;
